import { render, staticRenderFns } from "./DevPortalCreateOrUpdateUser.vue?vue&type=template&id=a9e6e58e"
import script from "./DevPortalCreateOrUpdateUser.vue?vue&type=script&lang=js"
export * from "./DevPortalCreateOrUpdateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports